import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ILoggerMeasurementsState,
  loggerMeasurementsAdapter,
  loggerMeasurementsKey,
} from './logger-measurements.state';

export const selectLoggerMeasurementsState = createFeatureSelector<ILoggerMeasurementsState>(loggerMeasurementsKey);

const { selectAll, selectEntities, selectIds, selectTotal } =
  loggerMeasurementsAdapter.getSelectors(selectLoggerMeasurementsState);

export const selectAllLoggerMeasurements = selectAll;
export const selectLoggerMeasurementEntities = selectEntities;
export const selectLoggerMeasurementIds = selectIds;
export const selectLoggerMeasurementsTotal = selectTotal;

export const selectLoggerMeasurementsLoading = createSelector(selectLoggerMeasurementsState, state => state.loading);
export const selectLoggerMeasurementsLoaded = createSelector(selectLoggerMeasurementsState, state => state.loaded);
export const selectLoggerMeasurementsError = createSelector(selectLoggerMeasurementsState, state => state.error);
export const selectPrevLoggerMeasurementsRequest = createSelector(
  selectLoggerMeasurementsState,
  state => state.request
);
